import React, { useEffect, useState } from "react";
import {
  Grid,
  IconButton,
  Typography,
  Autocomplete,
  Divider as MuiDivider,
  Box,
  TextField,
  Checkbox,
  Button,
  Tooltip,
} from "@mui/material";
import Add from "../../../../../../../assets/images/AddIcon.svg";
import Close from "../../../../../../../assets/images/CloseIcon.svg";
import CloseIcon from "@mui/icons-material/Close";
import Divider from "@mui/material/Divider";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import Switch from "@mui/material/Switch";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { toast } from "react-toastify";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";

const useStyles = makeStyles((theme) => ({
  root: {
    color: "#1B2430",
    backgroundColor: "#f5f5f5",

    "& .MuiPickersLayout-root-fgPIAm ": {
      backgroundColor: "#f5f5f5",
    },
    "& .MuiPickersLayout-root": {
      backgroundColor: " #f5f5f5",
    },
    "& .MuiList-root": {
      width: "75px",
      textAlign: "-webkit-center",
    },

    "& .MuiList-root-fLOhBn": {
      width: "75px",
      textAlign: "-webkit-center",
    },
    "& .MuiDialogActions-root": {
      display: "none",
    },
  },
}));

const Hours = ({
  itemIndex,
  periodsIndex,
  item,
  handleChangeCloseTime,
  handleChangeOpenTime,
  open,
  filteredPeriodsArr,
  setSelectedData,
  selectedData,
  getLocationDetails,
  periods,
  handleAddHours,
  handleRemoveHours,
  openTimesError,
  setOpenTimesError,
  setCloseTimesError,
  disableFields,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const userData = JSON.parse(localStorage.getItem("user"));
  const [openTimeValue, setOpenTimeValue] = useState("");
  const [closeTimeValue, setCloseTimeValue] = useState("");

  useEffect(() => {
    let OpenHoursValue;

    periods?.mergedTimes?.length > 0 &&
      periods?.mergedTimes?.map((item) => {
        if (item?.openHours !== undefined) {
          if (item?.openHours?.hours >= 10 || item?.openHours?.minutes >= 10) {
            if (item?.openHours?.hours === 24) {
              OpenHoursValue = "00:00";
            } else {
              OpenHoursValue =
                (item?.openHours?.hours && item?.openHours?.hours !== null
                  ? item?.openHours?.hours?.toString()
                  : "0") +
                ":" +
                (item?.openHours?.minutes
                  ? item?.openHours?.minutes?.toString() + ":" + "00"
                  : "00");
            }
          } else {
            OpenHoursValue =
              "0" +
              (item?.openHours?.hours && item?.openHours?.hours !== null
                ? item?.openHours?.hours?.toString()
                : "0") +
              ":" +
              (item?.openHours?.minutes && item?.openHours?.minutes !== null
                ? item?.openHours?.minutes?.toString() + ":" + "00"
                : "00");
          }
        } else {
          OpenHoursValue = "00:00";
        }
        const finalOpenValue = "Wed Jul 16 1997" + " " + OpenHoursValue; /* +
          " " +
          "GMT+0500 (Pakistan Standard Time)" */
        setOpenTimeValue(finalOpenValue);
        item["openTimesValueMerged"] = finalOpenValue;
      });
  }, [filteredPeriodsArr, selectedData]);
  useEffect(() => {
    let closeHoursValue;

    periods?.mergedTimes?.length > 0 &&
      periods?.mergedTimes?.map((item) => {
        if (
          item?.closedHours?.hours >= 10 ||
          item?.closedHours?.minutes >= 10
        ) {
          if (item?.closedHours?.hours === 24) {
            closeHoursValue = "00:00";
          } else {
            closeHoursValue =
              (item?.closedHours?.hours && item?.closedHours?.hours !== null
                ? item?.closedHours?.hours.toString()
                : "0") +
              ":" +
              (item?.closedHours?.minutes && item?.closedHours?.minutes !== null
                ? item?.closedHours?.minutes?.toString() + ":" + "00"
                : "00");
          }
        } else {
          closeHoursValue =
            "0" +
            (item?.closedHours?.hours && item?.closedHours?.hours !== null
              ? item?.closedHours?.hours.toString()
              : "0") +
            ":" +
            +(item?.closedHours?.minutes
              ? item?.closedHours?.minutes?.toString() + ":" + "00"
              : "00");
        }

        const finalCloseValue = "Wed Jul 16 1997" + " " + closeHoursValue; /* +
          " " +
          "GMT+0500 (Pakistan Standard Time)" */
        setCloseTimeValue(finalCloseValue);
        item["closeTimesValueMerged"] = finalCloseValue;
      });
  }, [filteredPeriodsArr, selectedData]);
  /*   useEffect(() => {
    let OpenHoursValue;

    if (periods?.openTime?.hours >= 10 || periods?.openTime?.minutes >= 10) {
      OpenHoursValue =
        (periods?.openTime?.hours && periods?.openTime?.hours !== null
          ? periods?.openTime?.hours?.toString()
          : "0") +
        ":" +
        (periods?.openTime?.minutes
          ? periods?.openTime?.minutes?.toString() + ":" + "00"
          : "00");
    } else {
      OpenHoursValue =
        "0" +
        (periods?.openTime?.hours && periods?.openTime?.hours !== null
          ? periods?.openTime?.hours?.toString()
          : "0") +
        ":" +
        "0" +
        (periods?.openTime?.minutes && periods?.openTime?.minutes !== null
          ? periods?.openTime?.minutes?.toString() + ":" + "0"
          : "0");
    }

    const finalOpenValue =
      "Wed Jul 16 1997" +
      " " +
      OpenHoursValue +
      " " +
      "GMT+0500 (Pakistan Standard Time)";
    setOpenTimeValue(finalOpenValue);
    
    
  }, [filteredPeriodsArr, selectedData]);
  useEffect(() => {
    let closeHoursValue;

    if (periods?.closeTime?.hours >= 10 || periods?.closeTime?.minutes >= 10) {
      closeHoursValue =
        (periods?.closeTime?.hours && periods?.closeTime?.hours !== null
          ? periods?.closeTime?.hours?.toString()
          : "0") +
        ":" +
        (periods?.closeTime?.minutes && periods?.closeTime?.minutes !== null
          ? periods?.closeTime?.minutes?.toString() + ":" + "00"
          : "00");
    } else {
      closeHoursValue =
        "0" +
        (periods?.closeTime?.hours && periods?.closeTime?.hours !== null
          ? periods?.closeTime?.hours?.toString()
          : "0") +
        ":" +
        "0" +
        (periods?.closeTime?.minutes && periods?.closeTime?.minutes !== null
          ? periods?.closeTime?.minutes?.toString() + ":" + "00"
          : "00");
    }

    const finalCloseValue =
      "Wed Jul 16 1997" +
      " " +
      closeHoursValue +
      " " +
      "GMT+0500 (Pakistan Standard Time)";
    setCloseTimeValue(finalCloseValue);
   
  }, [filteredPeriodsArr, selectedData]); */

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={5} sm={5} md={5} lg={5}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            {/* <DemoContainer components={["TimePicker"]}> */}
            <TimePicker
              style={{ width: "100%" }}
              ampm={userData?.timeFormat === "24" ? false : true}
              classes={{
                root: classes.root,
              }}
              disabled={disableFields}
              value={dayjs(item?.openTimesValueMerged)}
              onChange={(e) => {
                setSelectedData(periods);
                handleChangeOpenTime(e, itemIndex, item, periodsIndex);
              }}
              renderInput={(params) => (
                <TextField {...params} style={{ width: "100%" }} />
              )}
            />
            <style>
              {`
           .MuiDialogActions-root {
            display: none;
          }
         
        `}
            </style>
            {/* </DemoContainer> */}
          </LocalizationProvider>
        </Grid>
        <Grid item xs={1} sm={1} md={1} lg={1} sx={{ textAlign: "center" }}>
          <RemoveIcon sx={{ marginTop: "15px" }} />
        </Grid>
        <Grid item xs={5} sm={5} md={5} lg={5}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            {/* <DemoContainer components={["TimePicker"]}> */}
            <TimePicker
              style={{ width: "100%" }}
              ampm={userData?.timeFormat === "24" ? false : true}
              classes={{
                root: classes.root,
              }}
              disabled={disableFields}
              value={dayjs(item?.closeTimesValueMerged)}
              // minTime={new Date(item?.openTimesValueMerged)}
              onChange={(e) => {
                handleChangeCloseTime(e, itemIndex, item, periodsIndex);
                setSelectedData(periods);
              }}
              renderInput={(params) => (
                <TextField {...params} style={{ width: "100%" }} />
              )}
            />
            <style>
              {`
           .MuiDialogActions-root {
            display: none;
          }
         
        `}
            </style>
            {/* </DemoContainer> */}
          </LocalizationProvider>
        </Grid>
        <Grid item xs={1} sm={1} md={1} lg={1}>
          {itemIndex === 0 ? (
            <>
              <Tooltip title={t("Add_Hours")}>
                <IconButton
                  autoFocus
                  disabled={disableFields}
                  onClick={() => handleAddHours(periodsIndex, itemIndex)}
                  className="delete_button"
                >
                  <AddIcon sx={{ "&:hover ": { color: "#06BDFF" } }} />
                </IconButton>
              </Tooltip>
            </>
          ) : (
            <IconButton
              autoFocus
              disabled={disableFields}
              onClick={() => handleRemoveHours(periodsIndex, itemIndex)}
              className="delete_button"
            >
              <CloseIcon />
            </IconButton>
          )}
        </Grid>
      </Grid>
    </>
  );
};
export default Hours;
